import axios from "@/config/axios";

const state = {
  response: null,
  error: null,
};

const mutations = {
  SET_RESPONSE(state, data) {
    state.response = data;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async swapInsurance({ commit }, payload) {
    try {
      const res = await axios.post("/swapInsurance", payload);
      commit("SET_RESPONSE", res.data);
    } catch (err) {
      commit("SET_ERROR", err);
    }
  },
};

const getters = {
  insuranceResponse: (state) => state.response,
  insuranceError: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
